import { styled } from '@mui/material/styles'

export const FlexBox = styled('div')(
    ({ alignItems = 'center' }: { alignItems?: string }) => ({
        display: 'flex',
        alignItems
    })
)

export const FlexBoxColumn = styled('div')(
    ({ alignItems = 'center' }: { alignItems?: string }) => ({
        display: 'flex',
        flexFlow: 'column nowrap',
        alignItems
    })
)

export const FlexBoxSpaceBetween = styled(FlexBox)(() => ({
    justifyContent: 'space-between'
}))
